import { AxiosService } from 'network/config/config'
import { VaccinationTypesApi } from 'network/VaccinationType'
import { VaccinationFormsApi } from 'network/VaccinationForm'
import { MagicLinkApi } from 'network/MagicLink'
import { CalendarsApi } from 'network/Calendar'
import { PayStubsApi } from 'network/PayStub'
import { GroupsApi } from 'network/Group'
import { GroupInvitesApi } from 'network/GroupInvite'
import { GroupMembersApi } from 'network/GroupMember'
import { WebSocketDataApi } from 'network/WebSocketData'
import { SuggestedGroupNameApi } from 'network/SuggestedGroupName'
import { GroupApplicationsApi } from 'network/GroupApplication'
import { UserAchievementsApi } from 'network/UserAchievements'
import { ChallengesApi } from 'network/Challenges'
import { AchievementsApi } from 'network/Achievements'
import { StrikesApi } from 'network/Strike'
import { BackgroundChecksApi } from 'network/BackgroundChecks'
import { UpshifterExperiencesApi } from 'network/UpshifterExperience'
import { ScreeningDocumentsApi } from 'network/ScreeningDocument'
import { InterviewBotApi } from 'network/InterviewBot'
import { AuthApi } from './Auth'
import { AttachmentsApi } from './Attachment'
import { DocumentsApi } from './Document'
import { AcknowledgedDocumentsApi } from './AcknowledgedDocument'
import { UsersApi } from './User'
import { PunchCardsApi } from './PunchCard'
import { RegionApi } from './Region'
import { FavoritesApi } from './Favorite'
import { ShiftsApi } from './Shift'
import { AccruedSickHoursApi } from './AccruedSickHour'
import { ApplicationsApi } from './Applications'
import { GigDaysApi } from './GigDay'
import { ReliabilityRatingsApi } from './ReliabilityRating'
import { ReviewsApi } from './Review'
import { UserCertificatesApi } from './UserCertificate'
import { PasswordApi } from './Password'
import { NotificationPreferencesApi } from './NotificationPreference'
import { NotificationsApi } from './Notification'
import { ShortLinksApi } from './ShortLink'
import { FeaturedShiftsCampaignsApi } from './FeaturedShiftsCampaign'
import { ActivityLogsApi } from './ActivityLog'

class Api {
  axios = new AxiosService()

  Auth = new AuthApi(this.axios)

  Password = new PasswordApi(this.axios)

  Shifts = new ShiftsApi(this.axios)

  PunchCards = new PunchCardsApi(this.axios)

  Attachments = new AttachmentsApi(this.axios)

  Documents = new DocumentsApi(this.axios)

  AcknowledgedDocuments = new AcknowledgedDocumentsApi(this.axios)

  Users = new UsersApi(this.axios)

  Regions = new RegionApi(this.axios)

  Favorites = new FavoritesApi(this.axios)

  AccruedSickHours = new AccruedSickHoursApi(this.axios)

  Applications = new ApplicationsApi(this.axios)

  GigDays = new GigDaysApi(this.axios)

  ReliabilityRatings = new ReliabilityRatingsApi(this.axios)

  Reviews = new ReviewsApi(this.axios)

  UserCertificates = new UserCertificatesApi(this.axios)

  NotificationPreferences = new NotificationPreferencesApi(this.axios)

  Notifications = new NotificationsApi(this.axios)

  ShortLinks = new ShortLinksApi(this.axios)

  FeaturedShiftsCampaigns = new FeaturedShiftsCampaignsApi(this.axios)

  ActivityLogs = new ActivityLogsApi(this.axios)

  VaccinationTypes = new VaccinationTypesApi(this.axios)

  VaccinationForms = new VaccinationFormsApi(this.axios)

  MagicLink = new MagicLinkApi(this.axios)

  Calendars = new CalendarsApi(this.axios)

  PayStubs = new PayStubsApi(this.axios)

  Groups = new GroupsApi(this.axios)

  GroupInvites = new GroupInvitesApi(this.axios)

  GroupMembers = new GroupMembersApi(this.axios)

  WebSocketData = new WebSocketDataApi(this.axios)

  SuggestedGroupNames = new SuggestedGroupNameApi(this.axios)

  GroupApplications = new GroupApplicationsApi(this.axios)

  UserAchievements = new UserAchievementsApi(this.axios)

  Challenges = new ChallengesApi(this.axios)

  Achievements = new AchievementsApi(this.axios)

  Strikes = new StrikesApi(this.axios)

  BackgroundChecks = new BackgroundChecksApi(this.axios)

  UpshifterExperiences = new UpshifterExperiencesApi(this.axios)

  ScreeningDocuments = new ScreeningDocumentsApi(this.axios)

  InterviewBot = new InterviewBotApi(this.axios)
}

export const API = new Api()
